import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
// import { Api } from '@/service';

//restful api
import { actionLog as log } from '@/service/api/log'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

// props explain
// auto_refresh[default=false] : auth sync enable or disable, value is boolean
// user : this component to user list, using by user dependency

const i18n_fields = {
  EN: [
    { key: 'created_at', thStyle: 'width: 10%', sortable: true, label: 'Time' },
    { key: 'username', sortable: true, label: 'Username'},
    { key: 'source', sortable: false, label: 'From' },
    { key: 'addr', sortable: false, label: 'IP Address' },
    { key: 'action', sortable: false, label: 'Action' },
    { key: 'agent', sortable: false, label: 'Agent' },
    { key: 'func', sortable: false, label: 'Select' },
  ],
  KO: [
    { key: 'created_at', thStyle: 'width: 10%', sortable: true, label: '시간' },
    { key: 'username', sortable: true, label: '사용자명'},
    { key: 'source', sortable: false, label: '출처' },
    { key: 'addr', sortable: false, label: 'IP 주소' },
    { key: 'action', sortable: false, label: '행위' },
    { key: 'agent', sortable: false, label: '행위가 시도된 브라우저' },
    { key: 'func', sortable: false, label: '선택' },
  ]
}

export default {
  name : "ActionListAdmin",
  props: ['user', 'auto_refresh'],
  components: { DatePicker },
  data: () => ({
    color : ['info', 'danger', 'primary', 'secondary', 'warning', 'light'],
    custom,
    so : default_opt(),
    sync : { interval : 15, stop : false, th : undefined, enable : false },
    summaryData : [],
  }),
  computed: {
    _summary() { return this.summaryData },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      // let f = []
      
      // f = i18n_fields[this.i18n];
      // if(this.user) { f.splice(1, 1) }
      // return f;

      return i18n_fields[this.i18n]
    }
  },
  methods: {
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    refresh() {
      console.log("refresh", this.$route.name, new Date());
      if(this.$refs._list) {
        this.$refs._list.refresh();
        if(this.sync.enable) {
          this.sync.stop = false; this.pause();
        }
      }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let so = {
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * this.so.perPage, limit: this.so.perPage, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.user) { so.body.and.push({ name : 'admin_id', value : this.user.id, op : '=' }) }
      if(this.so.sk && this.so.sv && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)) }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      console.log("sk : ", so.sk)
      return log.listAdmin(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail: function(item) { console.info(item); this.$router.push(`/log/action/${item.id}/admin`); },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    }
    // summary() {
    //   let and = [];
    //   let id = undefined;
    //   if(this.user) { id = this.user.id; and.push({ name : 'admin_id', value : id, op : '='}) }
      // Api.Manager({ target : 'log.action.admin', cmd : 'summary.admin', body : { and : and, or : [], sort : [] } })
      //   .then(rs => this.summaryData = rs.body)
      //   .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    // },
  },
  created() { console.log('log.action.admin.vue', 'created'); },
  destroyed() { console.log('log.action.admin.vue', 'destroyed'); },
  mounted() {
    console.log('log.action.admin.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    if(this.user) {
      // this.so.sk = 'addr'
      // this.so.skt = 'Address'
      this.so.sk = ''
      this.so.skt = ''
    }
    // setTimeout(this.summary, 1000)
  },
}